import React, { useEffect, useState, useCallback } from "react";
import useAPI from "../../Hooks/useAPI";
import "./PermissionEditor.css";
import { default as Footer } from "../../Components/Footer/FooterSmall";
import '../../Components/Page/Page.css';
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faEdit, faPlus, faTags } from '@fortawesome/free-solid-svg-icons';

type Permission = { id: string; key: string; description: string };

export const PermissionEditor: React.FC = () => {
  const navigate = useNavigate();
  const {
    getPermissions,
    createPermission,
    updatePermission
  } = useAPI();
  const [permissions, setPermissions] = useState<Permission[]>([]);

  const [permKey, setPermKey] = useState("");
  const [permDesc, setPermDesc] = useState("");
  const [editingPermissionId, setEditingPermissionId] = useState<string | null>(null);

  const loadData = useCallback(async () => {
    const permData = await getPermissions();
    if (permData) setPermissions(permData);
  }, [getPermissions]);

  useEffect(() => {
    loadData();
  }, [loadData]);

  const handleEditPermission = (permission: Permission) => {
    setPermKey(permission.key);
    setPermDesc(permission.description);
    setEditingPermissionId(permission.id);
  };

  const handleSavePermission = async () => {
    if (editingPermissionId) {
      await updatePermission(editingPermissionId, permKey, permDesc);
    } else {
      await createPermission(permKey, permDesc);
    }
    setPermKey("");
    setPermDesc("");
    setEditingPermissionId(null);
    await loadData();
  };

  const cancelEdit = () => {
    setPermKey("");
    setPermDesc("");
    setEditingPermissionId(null);
  };

  return (
    <div className='generalPage'>
      <div className='pageContainer'>
        {/* <Header /> */}
        <div className="button-container">
          <button 
            className="back-button" 
            onClick={() => navigate('/user-admin')}
          >
            <FontAwesomeIcon icon={faArrowLeft} /> Back to Dashboard
          </button>
        </div>
        <div className="role-permission-editor">
          <div className="section-container">
            <h2><FontAwesomeIcon icon={faTags} /> Permissions</h2>
            <ul className="permission-list">
              {permissions.map((p) => (
                <li key={p.id}>
                  <div className="permission-info">
                    <span className="permission-key">{p.key}</span>
                    <span className="permission-desc">{p.description}</span>
                  </div>
                  <button onClick={() => handleEditPermission(p)} className="edit-button">
                    <FontAwesomeIcon icon={faEdit} /> Edit
                  </button>
                </li>
              ))}
            </ul>
            
            <div className="form-controls">
              <div className="permission-inputs">
                <input
                  type="text"
                  value={permKey}
                  onChange={(e) => setPermKey(e.target.value)}
                  placeholder="Permission Key"
                  className="input-field"
                />
                <input
                  type="text"
                  value={permDesc}
                  onChange={(e) => setPermDesc(e.target.value)}
                  placeholder="Description"
                  className="input-field"
                />
              </div>
              <div className="button-group">
                <button onClick={handleSavePermission} className="add-permission-button">
                  <FontAwesomeIcon icon={faPlus} /> {editingPermissionId ? "Update Permission" : "Add Permission"}
                </button>
                {editingPermissionId && (
                  <button onClick={cancelEdit} className="cancel-button">
                    Cancel
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};
